'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import is from 'is_js';
import uniqid from 'uniqid';
import MaskedInput from 'react-text-mask';
import TextInput from 'Components/Forms/Elements/TextInput';
import MuiPhoneNumber from 'material-ui-phone-number';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import DeleteIcon from '@material-ui/icons/Delete';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import getStateFromObject from 'Components/Forms/Functions/getStateFromObject';
import getFormData from 'Components/Forms/Functions/getFormData';
import bemit from 'Functions/bemit';
import Loader from 'Pure/Loader';
import { action } from 'Shared/Routes';
let app = window.app;
const qwest = window.qwest;
const SiretMask = React.forwardRef(function SiretMask(props, ref) {
  const setRef = React.useCallback(maskedInputRef => {
    const value = maskedInputRef ? maskedInputRef.inputElement : null;
    if (typeof ref === 'function') {
      ref(value);
    } else if (ref) {
      ref.current = value;
    }
  }, [ref]);
  return /*#__PURE__*/React.createElement(MaskedInput, _extends({}, props, {
    ref: setRef,
    mask: [/[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]
  }));
});
const TVAMask = React.forwardRef(function TVAMask(props, ref) {
  const setRef = React.useCallback(maskedInputRef => {
    const value = maskedInputRef ? maskedInputRef.inputElement : null;
    if (typeof ref === 'function') {
      ref(value);
    } else if (ref) {
      ref.current = value;
    }
  }, [ref]);
  return /*#__PURE__*/React.createElement(MaskedInput, _extends({}, props, {
    ref: setRef,
    mask: ['F', 'R', ' ', /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]
  }));
});
export default class UpdateMyCompanyForm extends Component {
  state = {
    status_messages: {},
    "company[roles]": ["company"],
    "company[authorized_domains]": []
  };
  handleChange = handleChange.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchCompany();
  }
  fetchCompany = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getAllCompanies'), {
      id: app?.state?.session?.user?.id,
      with_count: false
    }).then(function (xhr, response) {
      const company_roles = response.data[0].roles;
      delete response.data[0].roles;
      const authorized_domains = response.data[0].authorized_domains || [];
      delete response.data[0].authorized_domains;
      const update = getStateFromObject({
        data: response.data[0],
        model: 'company'
      });
      component.setState({
        ...update,
        "company[roles]": company_roles,
        "company[authorized_domains]": authorized_domains,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
    component.setState({});
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const company = getFormData({
      state: state,
      pattern: 'company['
    });
    qwest.post(action('UpdateMyCompany'), company).then(function (xhr, response) {
      component.fetchCompany();
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  addDomain = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let id = uniqid();
    let authorized_domains = state['company[authorized_domains]'];
    authorized_domains.push({
      domain: "",
      id: id
    });
    component.setState({
      'company[authorized_domains]': authorized_domains
    });
  };
  deleteDomain = authorized_domains_id => {
    const component = this,
      props = this.props,
      state = this.state;
    const authorized_domains_filtered = state['company[authorized_domains]'].filter(function (authorized_domains) {
      return authorized_domains['id'] !== authorized_domains_id;
    });
    component.setState({
      'company[authorized_domains]': authorized_domains_filtered
    });
  };
  handleDomainChange = ({
    e,
    value,
    name,
    id,
    field_name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let authorized_domains = (state['company[authorized_domains]'] || []).find(authorized_domains => authorized_domains.id === id);
    authorized_domains[field_name] = value;
    component.setState({
      authorized_domains: state.authorized_domains
    });
  };
  clearForm = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const update = Object.keys(state).filter(key => key.startsWith('company[')).reduce(function (update, key) {
      if (is.string(state[key])) {
        update[key] = '';
      } else if (is.array(state[key])) {
        update[key] = [];
      } else if (is.json(state[key])) {
        update[key] = {};
      }
      return update;
    }, {});
    component.setState(update);
  };
  handlePhoneChange = value => {
    const component = this,
      props = this.props,
      state = this.state;
    component.handleChange({
      e: undefined,
      value: value,
      name: 'company[phone_number]'
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = getFormStatus(state);
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let authorized_domain_list = (state['company[authorized_domains]'] || []).map(function (authorized_domain, i) {
      let modifiers = ['authorized_domain'];
      if (authorized_domain.id === state.open) modifiers.push('open');
      let output = /*#__PURE__*/React.createElement(Fragment, {
        key: authorized_domain.id
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/React.createElement(TextInput, {
        onChange: ({
          e,
          value,
          name
        }) => component.handleDomainChange({
          e,
          name,
          value,
          id: authorized_domain.id,
          field_name: 'domain'
        }),
        value: authorized_domain.domain,
        name: 'company[authorized_domain][' + authorized_domain.id + '][domain]',
        type: "text",
        label: "",
        status: state.status_messages
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        variant: "contained",
        size: "large",
        onClick: e => component.deleteDomain(authorized_domain.id)
      }, /*#__PURE__*/React.createElement(DeleteIcon, null))));
      return output;
    });
    let output = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("form", {
      method: "POST",
      className: "c-paper",
      action: "/company/admin-create"
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[name]'],
      name: "company[name]",
      type: "text",
      label: "Raison sociale",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[siret]'],
      name: "company[siret]",
      type: "text",
      label: "SIRET",
      inputComponent: SiretMask,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[num_tva]'],
      name: "company[num_tva]",
      type: "text",
      inputComponent: TVAMask,
      label: "Num\xE9ro TVA intracommunautaire",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(MuiPhoneNumber, {
      onChange: component.handlePhoneChange,
      value: state['company[phone_number]'],
      onlyCountries: ['fr'],
      defaultCountry: "fr",
      countryCodeEditable: true,
      label: "Num\xE9ro de t\xE9l\xE9phone",
      fullWidth: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[contact][lastname]'],
      name: "company[contact][lastname]",
      type: "text",
      label: "Nom du contact principal",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[contact][firstname]'],
      name: "company[contact][firstname]",
      type: "text",
      label: "Pr\xE9nom du contact principal",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[address][line_1]'],
      name: "company[address][line_1]",
      type: "text",
      label: "Adresse du si\xE8ge social",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[address][line_2]'],
      name: "company[address][line_2]",
      type: "text",
      label: "Compl\xE9ment d'adresse du si\xE8ge social",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[address][postal_code]'],
      name: "company[address][postal_code]",
      type: "text",
      label: "Code postal du si\xE8ge social",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[address][city]'],
      name: "company[address][city]",
      type: "text",
      label: "Ville du si\xE8ge social",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[address][country]'],
      name: "company[address][country]",
      type: "text",
      label: "Pays du si\xE8ge social",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['company[login]'],
      name: "company[login]",
      type: "text",
      label: "E-mail de connexion",
      autocomplete: "new-email",
      status: state.status_messages
    }))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      classes: props.classes
    }, /*#__PURE__*/React.createElement("p", null, "Indiquer les noms de domaine autoris\xE9s \xE0 se connecter \xE0 l\u2019interface sous la forme : nomdelentreprise.com"), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.addDomain
    }, "Ajouter un domaine")), authorized_domain_list), status), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-text-center\r u-margin-top-25 u-padding-bottom-20 "
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.validate
    }, "Mettre \xE0 jour", loader)));
    return output;
  }
}
